import { render, staticRenderFns } from "./ProhibitedItemsDisplay.vue?vue&type=template&id=3e1c890e&scoped=true&"
import script from "./ProhibitedItemsDisplay.vue?vue&type=script&lang=js&"
export * from "./ProhibitedItemsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1c890e",
  null
  
)

export default component.exports